import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { Top100Page } from './pages/Top100Page';
import { WalletDetailPage } from './pages/WalletDetailPage';
import { MethodologyPage } from './pages/MethodologyPage';
import { GoogleAnalytics } from './components/GoogleAnalytics';
export function App() {
  return <BrowserRouter data-id="element-0">
      <GoogleAnalytics data-id="element-1" />
      <div className="min-h-screen bg-gray-950 flex flex-col" data-id="element-2">
        <Header data-id="element-3" />
        <main className="flex-1" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/top100" element={<Top100Page data-id="element-9" />} data-id="element-8" />
            <Route path="/wallet/:address" element={<WalletDetailPage data-id="element-11" />} data-id="element-10" />
            <Route path="/methodology" element={<MethodologyPage data-id="element-13" />} data-id="element-12" />
          </Routes>
        </main>
        <Footer data-id="element-14" />
      </div>
    </BrowserRouter>;
}